export const PalletAreaStatus = {
  Available: {
    label: 'Liberado',
    color: '#57c278',
  },
  Blocked: {
    label: 'Bloqueado',
    color: '#eb3681',
  },
}
export default function (status) {
  for (const key in PalletAreaStatus) {
    const s = PalletAreaStatus[key]
    if (s.label === status) return PalletAreaStatus[key]
  }
}
